import React from 'react'
import PropTypes from 'prop-types'
import moment from '../../helpers/momentUtils'
import Icon from '../Icon/Icon'
import './FlightsSummary.scss'

const sortFlightArray = selectedFlights => {
  const outboundFlights = selectedFlights.filter(x => x.type === 'outbound')
  const inboundFlights = selectedFlights.filter(x => x.type === 'inbound')
  return [...outboundFlights, ...inboundFlights]
}

const FlightsSummary = ({ selectedFlights, removeFlight }) => {
  const sortedFlights = sortFlightArray(selectedFlights)

  return sortedFlights.map(({ routeId, flights, routeName }) => {
    return (
      <div className="FlightsSummary__route" key={routeId}>
        <h4>{routeName}</h4>
        <table>
          <tbody>
            {flights.map(flight => {
              const departureDate = moment(flight.departureDateTime)
              const arrivalDate = moment(flight.arrivalDateTime)
              return (
                <tr className="FlightsSummary__flight" key={flight.id}>
                  <td>{departureDate.format('ddd')}</td>
                  <td>{departureDate.format('D')}</td>
                  <td>{departureDate.format('MMM')}</td>
                  <td>{departureDate.format('HH:mm')}</td>
                  <td className="FlightsSummary__dash-centered">-</td>
                  <td>{arrivalDate.format('HH:mm')}</td>
                  <td>
                    <button
                      className="FlightsSummary__remove"
                      onClick={() => removeFlight(routeId, flight.id)}
                    >
                      <Icon name="error" />
                    </button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  })
}

FlightsSummary.propTypes = {
  selectedFlights: PropTypes.array,
  removeFlight: PropTypes.func,
}

export default FlightsSummary
